import { NavLink } from 'react-router-dom'
import {
  Package,
  ClipboardList,
  Receipt,
  FileText,
  Clock,
  Truck,
  Users,
  Warehouse,
  Wrench,
  TrendingUp,
  Settings,
} from 'lucide-react'

interface NavItem {
  label: string
  path: string
  icon: React.ReactNode
}

interface NavGroup {
  title: string
  items: NavItem[]
}

const navigation: NavGroup[] = [
  {
    title: 'Daglig',
    items: [
      { label: 'Oppgaver', path: '/oppgaver', icon: <ClipboardList size={18} /> },
      { label: 'Ordrer', path: '/orders', icon: <Package size={18} /> },
    ],
  },
  {
    title: 'Salg',
    items: [
      { label: 'Tilbud', path: '/salg/tilbud', icon: <Receipt size={18} /> },
      { label: 'Salgsordre', path: '/salg/ordrer', icon: <FileText size={18} /> },
    ],
  },
  {
    title: 'Verksted',
    items: [
      { label: 'Skrotanalyse', path: '/verksted/skrot', icon: <Wrench size={18} /> },
    ],
  },
  {
    title: 'Analyse',
    items: [
      { label: 'Salg', path: '/analyse/salg', icon: <TrendingUp size={18} /> },
      { label: 'Leveringstid', path: '/analyse/leveringstid', icon: <Clock size={18} /> },
      { label: 'Utleveringer', path: '/analyse/utleveringer', icon: <Truck size={18} /> },
      { label: 'Kunder', path: '/analyse/kunder', icon: <Users size={18} /> },
      { label: 'Lager', path: '/analyse/lager', icon: <Warehouse size={18} /> },
    ],
  },
  {
    title: 'System',
    items: [
      { label: 'Innstillinger', path: '/innstillinger', icon: <Settings size={18} /> },
    ],
  },
]

export function Sidebar() {
  return (
    <aside className="w-56 flex-shrink-0 bg-white border-r border-gray-200/80 flex flex-col">
      <nav className="flex-1 py-4 px-3 space-y-7">
        {navigation.map((group) => (
          <div key={group.title}>
            <p className="px-3 mb-1.5 text-[11px] font-semibold text-gray-400 uppercase tracking-wider">
              {group.title}
            </p>
            <ul className="space-y-0.5">
              {group.items.map((item) => (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-colors ${
                        isActive
                          ? 'bg-gray-100 text-gray-900 font-medium'
                          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                      }`
                    }
                  >
                    {item.icon}
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  )
}
